import { render, staticRenderFns } from "./team.vue?vue&type=template&id=815912ce&"
import script from "./team.ts?vue&type=script&lang=js&"
export * from "./team.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports